import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { BaseComponent } from '../../../../../common/components/base.component';
import { HubFeed } from '../../../../../models/hub/hub.feed';
import { HubFacebookFeedsCommand } from '../../../../../commands/hub/event/add.facebook.general.feed.command';
import {
  HubCalendarStore,
  HubFacebookLocationFeedsStore,
  HubFacebookPageFeedsStore,
  UpdateGeoLocationStore,
} from '../../../../../stores/hub.calendar.store';
import {
  ConfirmModalActions,
  ConfirmModalData,
} from '../../../../../common/components/confirm.modal/confirm.modal.provider';
import { ButtonTriggerEvent } from '../../../../../common/components';
import { ConfirmModalComponent } from '../../../../../common/components/confirm.modal/confirm.modal.component';
import { HubApiService } from '../../../../../services/hub.api.service';
import { ModalService } from '../../../../../common/services/modal.service';
import { Observable } from 'rxjs/Observable';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { HubCalendarActionCommand } from '../../../../../commands/pagination.query.command';
import { clone } from '../../../../../common/extensions';

@Component({
  selector: 'ig-location-feed-list',
  templateUrl: './location.feed.list.component.html',
  styleUrls: ['./location.feed.list.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LocationFeedListComponent extends BaseComponent implements OnInit {
  @Input() public type: 'event' | 'place';
  // public type = 'event';
  public hubName: string;
  public isLoadingFeeds = false;
  public hubLocations: HubFeed[];
  public hubPages: HubFeed[];
  public placeSource = 'google';

  constructor(
    private router: Router,
    private hubCalendarStore: HubCalendarStore,
    private hubFacebookLocationFeedsStore: HubFacebookLocationFeedsStore,
    private hubApiService: HubApiService,
    private activatedRoute: ActivatedRoute,
    private hubFacebookFeedsStore: HubFacebookPageFeedsStore,
    private updateGeoLocationStore: UpdateGeoLocationStore,
    private modalService: ModalService
  ) {
    super({ activatedRoute });
  }

  public ngOnInit() {
    let { hubName } = this.allRouteParams;
    this.hubName = hubName;

    this.hubCalendarStore.actionCommand.takeUntil(this.isDestroyed).subscribe((command: HubCalendarActionCommand) => {
      if (command && command.queryParams && command.queryParams.source) {
        this.placeSource = command.queryParams.source;
      }
    });

    this.getHubLocations();

    this.hubFacebookLocationFeedsStore.locationCommand
      .takeUntil(this.isDestroyed)
      .subscribe((hubLocations: HubFacebookFeedsCommand) => {
        this.filterByType(hubLocations.hubPages);
      });
  }

  editLocationFeed(location: HubFeed) {
    this.updateGeoLocationStore.updateGeoLocationCommand.next(clone(location));
  }

  deleteLocationFeed(location: HubFeed) {
    let actions = <ConfirmModalActions>{
      confirm: (feed: ButtonTriggerEvent) => {
        this.hubApiService
          .removeLocationFeed(this.hubName, location.id, location.socialName)
          .finally(feed.complete)
          .subscribe(() => {
            this.getHubLocations();
          });
      },
    };

    let data = <ConfirmModalData>{
      confirmModalIcon: 'warning',
      confirmModalTitle: 'Alert',
      confirmModalDescription: 'Are you sure you want to remove this Location?',
      confirmModalConfirmButtonText: 'Remove',
      confirmModalCancelButtonText: 'Cancel',
      confirmCheckboxDescription:
        'If geofences are deleted, the entire existing database of places will be deleted, along with the categories and any other promotional labels such as “Editor’s Choice” etc.',
      isAsync: true,
    };

    this.modalService.show({
      component: ConfirmModalComponent,
      providers: [
        { provide: ConfirmModalActions, useValue: actions },
        { provide: ConfirmModalData, useValue: data },
      ],
    });
  }

  public deleteEventFeed(page: HubFeed) {
    let actions = <ConfirmModalActions>{
      confirm: (feed: ButtonTriggerEvent) => {
        this.hubApiService
          .removePageFeed(this.hubName, page.id)
          .finally(feed.complete)
          .subscribe(() => {
            this.getHubPageFeeds();
          });
      },
    };

    let data = <ConfirmModalData>{
      confirmModalIcon: 'warning',
      confirmModalTitle: 'Alert',
      confirmModalDescription: 'Are you sure you want to remove this page?',
      confirmModalConfirmButtonText: 'Remove',
      confirmModalCancelButtonText: 'Cancel',
      isAsync: true,
    };

    this.modalService.show({
      component: ConfirmModalComponent,
      providers: [
        { provide: ConfirmModalActions, useValue: actions },
        { provide: ConfirmModalData, useValue: data },
      ],
    });
  }

  private getHubPageFeeds() {
    let times = 0;
    let getFeeds = () =>
      this.hubApiService
        .getPageFeeds(this.hubName)
        .catch((err) => {
          if (times < 3) {
            getFeeds();
          }
          times++;
          return Observable.throw(err.statusText);
        })
        .subscribe((data) => {
          this.hubPages = data;
          let pageCommand = new HubFacebookFeedsCommand(data);
          this.hubFacebookFeedsStore.pagesCommand.next(pageCommand);
        });
    getFeeds();
  }

  private getHubLocations() {
    let times = 0;
    this.isLoadingFeeds = true;
    let getFeeds = () =>
      this.hubApiService
        .getLocationFeeds(this.hubName)
        .catch((err) => {
          if (times < 3) {
            getFeeds();
          }
          times++;
          return Observable.throw(err.statusText);
        })
        .subscribe((data) => {
          this.isLoadingFeeds = false;
          this.hubLocations = data;
          this.hubFacebookLocationFeedsStore.locationCommand.next(new HubFacebookFeedsCommand(data));
          this.filterByType(data);
        });
    getFeeds();
  }

  private filterByType(locations) {
    setTimeout(() => {
      if (locations && locations.length) {
        if (this.type === 'event') {
          this.hubLocations = locations.filter((x) => x.socialName === 'eventful');
        } else if (this.type === 'place') {
          this.hubLocations = locations.filter((x) => x.socialName === this.placeSource);
        } else {
          this.hubLocations = locations;
        }
      }
    });
  }

  private copyToClip(content) {
    let aux = document.createElement('input');
    aux.setAttribute('value', content);
    document.body.appendChild(aux);
    aux.select();
    document.execCommand('copy');
    document.body.removeChild(aux);
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/edit.account/content.management/location.feed.list/location.feed.list.component.ts